import { createSlice } from '@reduxjs/toolkit'
import { isEqual } from 'lodash'
import { useSelector } from 'react-redux'
import mapApi from '~map-search/services/map'

const initialState = {
  data: {
    searchMaps: {
      items: [],
      size: 0,
      total: 0
    }
  },
  hasMoreItems: undefined,
  currentArgs: {}
}

export const infiniteScrollSlice = createSlice({
  name: 'infiniteScroll',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addMatcher(mapApi.endpoints.searchMaps.matchPending, (state, action) => {
        const currentArgs = action.meta.arg.originalArgs

        const isFromZero = currentArgs.from === 0

        const isFeedTypeChanged =
          state.currentArgs?.feedType !== currentArgs.feedType

        const isTagIdsChanged = !isEqual(
          state.currentArgs?.tagIds,
          currentArgs.tagIds
        )

        // Reset if feedType, tagIds, or query from 0
        if (isFeedTypeChanged || isTagIdsChanged || isFromZero) {
          state.data.searchMaps.items = []
          state.data.searchMaps.total = 0
          state.data.searchMaps.size = 0
        }

        state.currentArgs = currentArgs
      })
      .addMatcher(
        mapApi.endpoints.searchMaps.matchFulfilled,
        (state, action) => {
          const { items, total } = action.payload.searchMaps

          state.data.searchMaps.items.push(...items)
          state.data.searchMaps.total = total
          // Update the size after items being pushed
          state.data.searchMaps.size = state.data.searchMaps.items.length
          state.hasMoreItems = total - state.data.searchMaps.size > 0
        }
      )
      .addMatcher(
        mapApi.endpoints.searchMaps.matchRejected,
        (state, { error }) => {
          // Clear the items if error
          if (error) {
            state.data.searchMaps.items = []
            state.data.searchMaps.total = 0
            state.data.searchMaps.size = 0
            state.hasMoreItems = false
          }
        }
      )
  }
})

export const {} = infiniteScrollSlice.actions

const selectInfiniteScroll = (state) => state.infiniteScroll

const useInfiniteSearchMapsState = () => useSelector(selectInfiniteScroll)

export { useInfiniteSearchMapsState }
export default infiniteScrollSlice.reducer
